import React, { FC, memo, ReactNode } from "react";

import { EworkLogo, IEworkLogoVariant } from "./EworkLogo";
import { ILogoProps, Logo } from "./Logo";

export interface IBrandedLogoProps extends Omit<ILogoProps, "src"> {
  src?: ILogoProps["src"] | null;
  variant?: IEworkLogoVariant;
  placeholder?: ReactNode;
}

export const BrandedLogo: FC<IBrandedLogoProps> = memo(({ src, variant, placeholder, ...props }) => {
  return src ? (
    <Logo src={src} {...props} />
  ) : placeholder ? (
    <>{placeholder}</>
  ) : (
    <EworkLogo variant={variant} {...props} />
  );
});
